/* AUTO GENERATED CONTENT: DO NOT MODIFY THIS FILE. SEE /TOOLS FOLDER FOR CHANGES */

export const palette = {
  'box-neutral-default': 'inset 0px 0px 0px 1px rgba(142, 168, 190, 0.16)',
  'box-neutral-default-out': '0px 0px 0px 1px rgba(142, 168, 190, 0.16)',
  'box-neutral-default-right-divider': 'inset -1px 0px 0px rgba(142, 168, 190, 0.16)',
  'box-neutral-default-left-divider': 'inset 1px 0px 0px rgba(142, 168, 190, 0.16)',
  'box-neutral-default-bottom-divider': 'inset 0px -1px 0px rgba(142, 168, 190, 0.16)',
  'box-neutral-default-top-divider': 'inset 0px 1px 0px rgba(142, 168, 190, 0.16)',
  'box-neutral-default-y-divider':
    'inset 0px -1px 0px rgba(142, 168, 190, 0.16), inset 0px 1px 0px rgba(142, 168, 190, 0.16)',
  'box-neutral-default-x-divider':
    'inset -1px 0px 0px rgba(142, 168, 190, 0.16), inset 1px 0px 0px rgba(142, 168, 190, 0.16)',
  'shadow-bevel-neutral-default':
    'inset 0 0 0 0.0625rem rgba(38, 52, 64, 0.08), inset 0 -0.0625rem 0 0 rgba(38, 52, 64, 0.24)',
  'outline-sm-neutral-dark-32':
    'inset 0 0 0 0.0625rem rgba(38, 52, 64, 0.32), 0 0 0 0.125rem rgba(38, 52, 64, 0.08)',
  'outline-md-neutral-dark-32':
    'inset 0 0 0 0.0625rem rgba(38, 52, 64, 0.32), 0 0 0 0.25rem rgba(38, 52, 64, 0.08)',
  'outline-md-neutral-dark-100':
    'inset 0 0 0 0.0625rem rgba(38, 52, 64, 1), 0 0 0 0.25rem rgba(38, 52, 64, 0.12)',
  'outline-md-purple-dark-100':
    'inset 0 0 0 0.0625rem rgba(84, 61, 255, 1), 0 0 0 0.25rem rgba(84, 61, 255, 0.12)',
  'outline-md-teal-dark-100':
    'inset 0 0 0 0.0625rem rgba(0, 141, 163, 1), 0 0 0 0.25rem rgba(0, 141, 163, 0.12)',
  'outline-md-orange-dark-100':
    'inset 0 0 0 0.0625rem rgba(255, 85, 0, 1), 0 0 0 0.25rem rgba(255, 85, 0, 0.12)',
  'outline-md-red-dark-100':
    'inset 0 0 0 0.0625rem rgba(214, 64, 61, 1), 0 0 0 0.25rem rgba(214, 64, 61, 0.12)',
  'outline-md-yellow-dark-100':
    'inset 0 0 0 0.0625rem rgba(194, 113, 0, 1), 0 0 0 0.25rem rgba(194, 113, 0, 0.12)',
  'outline-md-blue-dark-100':
    'inset 0 0 0 0.0625rem rgba(0, 118, 214, 1), 0 0 0 0.25rem rgba(0, 118, 214, 0.12)',
  'outline-md-green-dark-100':
    'inset 0 0 0 0.0625rem rgba(0, 133, 99, 1), 0 0 0 0.25rem rgba(0, 133, 99, 0.12)',
  'shadow-bevel-neutral-darker':
    'inset 0 0 0 0.0625rem rgba(38, 52, 64, 0.12), inset 0 -0.0625rem 0 0 rgba(38, 52, 64, 0.24)',
  'inline-xs-neutral-dark-2': 'inset 0 0 0 0.0625rem rgba(38, 52, 64, 0.02)',
  'inline-xs-neutral-light-2': 'inset 0 0 0 0.0625rem rgba(207, 218, 226, 0.02)',
  'inline-xs-purple-dark-2': 'inset 0 0 0 0.0625rem rgba(84, 61, 255, 0.02)',
  'inline-xs-purple-light-2': 'inset 0 0 0 0.0625rem rgba(165, 153, 255, 0.02)',
  'inline-xs-teal-dark-2': 'inset 0 0 0 0.0625rem rgba(0, 141, 163, 0.02)',
  'inline-xs-teal-light-2': 'inset 0 0 0 0.0625rem rgba(100, 170, 180, 0.02)',
  'inline-xs-orange-dark-2': 'inset 0 0 0 0.0625rem rgba(255, 85, 0, 0.02)',
  'inline-xs-orange-light-2': 'inset 0 0 0 0.0625rem rgba(246, 126, 85, 0.02)',
  'inline-xs-red-dark-2': 'inset 0 0 0 0.0625rem rgba(214, 64, 61, 0.02)',
  'inline-xs-red-light-2': 'inset 0 0 0 0.0625rem rgba(255, 105, 102, 0.02)',
  'inline-xs-yellow-dark-2': 'inset 0 0 0 0.0625rem rgba(194, 113, 0, 0.02)',
  'inline-xs-yellow-light-2': 'inset 0 0 0 0.0625rem rgba(255, 159, 26, 0.02)',
  'inline-xs-green-dark-2': 'inset 0 0 0 0.0625rem rgba(0, 133, 99, 0.02)',
  'inline-xs-green-light-2': 'inset 0 0 0 0.0625rem rgba(0, 189, 142, 0.02)',
  'inline-xs-blue-dark-2': 'inset 0 0 0 0.0625rem rgba(0, 118, 214, 0.02)',
  'inline-xs-blue-light-2': 'inset 0 0 0 0.0625rem rgba(41, 159, 255, 0.02)',
  'inline-xs-white-2': 'inset 0 0 0 0.0625rem rgba(255, 255, 255, 0.02)',
  'inline-xs-neutral-dark-3': 'inset 0 0 0 0.0625rem rgba(38, 52, 64, 0.03)',
  'inline-xs-neutral-light-3': 'inset 0 0 0 0.0625rem rgba(207, 218, 226, 0.03)',
  'inline-xs-purple-dark-3': 'inset 0 0 0 0.0625rem rgba(84, 61, 255, 0.03)',
  'inline-xs-purple-light-3': 'inset 0 0 0 0.0625rem rgba(165, 153, 255, 0.03)',
  'inline-xs-teal-dark-3': 'inset 0 0 0 0.0625rem rgba(0, 141, 163, 0.03)',
  'inline-xs-teal-light-3': 'inset 0 0 0 0.0625rem rgba(100, 170, 180, 0.03)',
  'inline-xs-orange-dark-3': 'inset 0 0 0 0.0625rem rgba(255, 85, 0, 0.03)',
  'inline-xs-orange-light-3': 'inset 0 0 0 0.0625rem rgba(246, 126, 85, 0.03)',
  'inline-xs-red-dark-3': 'inset 0 0 0 0.0625rem rgba(214, 64, 61, 0.03)',
  'inline-xs-red-light-3': 'inset 0 0 0 0.0625rem rgba(255, 105, 102, 0.03)',
  'inline-xs-yellow-dark-3': 'inset 0 0 0 0.0625rem rgba(194, 113, 0, 0.03)',
  'inline-xs-yellow-light-3': 'inset 0 0 0 0.0625rem rgba(255, 159, 26, 0.03)',
  'inline-xs-green-dark-3': 'inset 0 0 0 0.0625rem rgba(0, 133, 99, 0.03)',
  'inline-xs-green-light-3': 'inset 0 0 0 0.0625rem rgba(0, 189, 142, 0.03)',
  'inline-xs-blue-dark-3': 'inset 0 0 0 0.0625rem rgba(0, 118, 214, 0.03)',
  'inline-xs-blue-light-3': 'inset 0 0 0 0.0625rem rgba(41, 159, 255, 0.03)',
  'inline-xs-white-3': 'inset 0 0 0 0.0625rem rgba(255, 255, 255, 0.03)',
  'inline-xs-neutral-dark-4': 'inset 0 0 0 0.0625rem rgba(38, 52, 64, 0.04)',
  'inline-xs-neutral-light-4': 'inset 0 0 0 0.0625rem rgba(207, 218, 226, 0.04)',
  'inline-xs-purple-dark-4': 'inset 0 0 0 0.0625rem rgba(84, 61, 255, 0.04)',
  'inline-xs-purple-light-4': 'inset 0 0 0 0.0625rem rgba(165, 153, 255, 0.04)',
  'inline-xs-teal-dark-4': 'inset 0 0 0 0.0625rem rgba(0, 141, 163, 0.04)',
  'inline-xs-teal-light-4': 'inset 0 0 0 0.0625rem rgba(100, 170, 180, 0.04)',
  'inline-xs-orange-dark-4': 'inset 0 0 0 0.0625rem rgba(255, 85, 0, 0.04)',
  'inline-xs-orange-light-4': 'inset 0 0 0 0.0625rem rgba(246, 126, 85, 0.04)',
  'inline-xs-red-dark-4': 'inset 0 0 0 0.0625rem rgba(214, 64, 61, 0.04)',
  'inline-xs-red-light-4': 'inset 0 0 0 0.0625rem rgba(255, 105, 102, 0.04)',
  'inline-xs-yellow-dark-4': 'inset 0 0 0 0.0625rem rgba(194, 113, 0, 0.04)',
  'inline-xs-yellow-light-4': 'inset 0 0 0 0.0625rem rgba(255, 159, 26, 0.04)',
  'inline-xs-green-dark-4': 'inset 0 0 0 0.0625rem rgba(0, 133, 99, 0.04)',
  'inline-xs-green-light-4': 'inset 0 0 0 0.0625rem rgba(0, 189, 142, 0.04)',
  'inline-xs-blue-dark-4': 'inset 0 0 0 0.0625rem rgba(0, 118, 214, 0.04)',
  'inline-xs-blue-light-4': 'inset 0 0 0 0.0625rem rgba(41, 159, 255, 0.04)',
  'inline-xs-white-4': 'inset 0 0 0 0.0625rem rgba(255, 255, 255, 0.04)',
  'inline-xs-neutral-dark-8': 'inset 0 0 0 0.0625rem rgba(38, 52, 64, 0.08)',
  'inline-xs-neutral-light-8': 'inset 0 0 0 0.0625rem rgba(207, 218, 226, 0.08)',
  'inline-xs-purple-dark-8': 'inset 0 0 0 0.0625rem rgba(84, 61, 255, 0.08)',
  'inline-xs-purple-light-8': 'inset 0 0 0 0.0625rem rgba(165, 153, 255, 0.08)',
  'inline-xs-teal-dark-8': 'inset 0 0 0 0.0625rem rgba(0, 141, 163, 0.08)',
  'inline-xs-teal-light-8': 'inset 0 0 0 0.0625rem rgba(100, 170, 180, 0.08)',
  'inline-xs-orange-dark-8': 'inset 0 0 0 0.0625rem rgba(255, 85, 0, 0.08)',
  'inline-xs-orange-light-8': 'inset 0 0 0 0.0625rem rgba(246, 126, 85, 0.08)',
  'inline-xs-red-dark-8': 'inset 0 0 0 0.0625rem rgba(214, 64, 61, 0.08)',
  'inline-xs-red-light-8': 'inset 0 0 0 0.0625rem rgba(255, 105, 102, 0.08)',
  'inline-xs-yellow-dark-8': 'inset 0 0 0 0.0625rem rgba(194, 113, 0, 0.08)',
  'inline-xs-yellow-light-8': 'inset 0 0 0 0.0625rem rgba(255, 159, 26, 0.08)',
  'inline-xs-green-dark-8': 'inset 0 0 0 0.0625rem rgba(0, 133, 99, 0.08)',
  'inline-xs-green-light-8': 'inset 0 0 0 0.0625rem rgba(0, 189, 142, 0.08)',
  'inline-xs-blue-dark-8': 'inset 0 0 0 0.0625rem rgba(0, 118, 214, 0.08)',
  'inline-xs-blue-light-8': 'inset 0 0 0 0.0625rem rgba(41, 159, 255, 0.08)',
  'inline-xs-white-8': 'inset 0 0 0 0.0625rem rgba(255, 255, 255, 0.08)',
  'inline-xs-neutral-dark-12': 'inset 0 0 0 0.0625rem rgba(38, 52, 64, 0.12)',
  'inline-xs-neutral-light-12': 'inset 0 0 0 0.0625rem rgba(207, 218, 226, 0.12)',
  'inline-xs-purple-dark-12': 'inset 0 0 0 0.0625rem rgba(84, 61, 255, 0.12)',
  'inline-xs-purple-light-12': 'inset 0 0 0 0.0625rem rgba(165, 153, 255, 0.12)',
  'inline-xs-teal-dark-12': 'inset 0 0 0 0.0625rem rgba(0, 141, 163, 0.12)',
  'inline-xs-teal-light-12': 'inset 0 0 0 0.0625rem rgba(100, 170, 180, 0.12)',
  'inline-xs-orange-dark-12': 'inset 0 0 0 0.0625rem rgba(255, 85, 0, 0.12)',
  'inline-xs-orange-light-12': 'inset 0 0 0 0.0625rem rgba(246, 126, 85, 0.12)',
  'inline-xs-red-dark-12': 'inset 0 0 0 0.0625rem rgba(214, 64, 61, 0.12)',
  'inline-xs-red-light-12': 'inset 0 0 0 0.0625rem rgba(255, 105, 102, 0.12)',
  'inline-xs-yellow-dark-12': 'inset 0 0 0 0.0625rem rgba(194, 113, 0, 0.12)',
  'inline-xs-yellow-light-12': 'inset 0 0 0 0.0625rem rgba(255, 159, 26, 0.12)',
  'inline-xs-green-dark-12': 'inset 0 0 0 0.0625rem rgba(0, 133, 99, 0.12)',
  'inline-xs-green-light-12': 'inset 0 0 0 0.0625rem rgba(0, 189, 142, 0.12)',
  'inline-xs-blue-dark-12': 'inset 0 0 0 0.0625rem rgba(0, 118, 214, 0.12)',
  'inline-xs-blue-light-12': 'inset 0 0 0 0.0625rem rgba(41, 159, 255, 0.12)',
  'inline-xs-white-12': 'inset 0 0 0 0.0625rem rgba(255, 255, 255, 0.12)',
  'inline-xs-neutral-dark-16': 'inset 0 0 0 0.0625rem rgba(38, 52, 64, 0.16)',
  'inline-xs-neutral-light-16': 'inset 0 0 0 0.0625rem rgba(207, 218, 226, 0.16)',
  'inline-xs-purple-dark-16': 'inset 0 0 0 0.0625rem rgba(84, 61, 255, 0.16)',
  'inline-xs-purple-light-16': 'inset 0 0 0 0.0625rem rgba(165, 153, 255, 0.16)',
  'inline-xs-teal-dark-16': 'inset 0 0 0 0.0625rem rgba(0, 141, 163, 0.16)',
  'inline-xs-teal-light-16': 'inset 0 0 0 0.0625rem rgba(100, 170, 180, 0.16)',
  'inline-xs-orange-dark-16': 'inset 0 0 0 0.0625rem rgba(255, 85, 0, 0.16)',
  'inline-xs-orange-light-16': 'inset 0 0 0 0.0625rem rgba(246, 126, 85, 0.16)',
  'inline-xs-red-dark-16': 'inset 0 0 0 0.0625rem rgba(214, 64, 61, 0.16)',
  'inline-xs-red-light-16': 'inset 0 0 0 0.0625rem rgba(255, 105, 102, 0.16)',
  'inline-xs-yellow-dark-16': 'inset 0 0 0 0.0625rem rgba(194, 113, 0, 0.16)',
  'inline-xs-yellow-light-16': 'inset 0 0 0 0.0625rem rgba(255, 159, 26, 0.16)',
  'inline-xs-green-dark-16': 'inset 0 0 0 0.0625rem rgba(0, 133, 99, 0.16)',
  'inline-xs-green-light-16': 'inset 0 0 0 0.0625rem rgba(0, 189, 142, 0.16)',
  'inline-xs-blue-dark-16': 'inset 0 0 0 0.0625rem rgba(0, 118, 214, 0.16)',
  'inline-xs-blue-light-16': 'inset 0 0 0 0.0625rem rgba(41, 159, 255, 0.16)',
  'inline-xs-white-16': 'inset 0 0 0 0.0625rem rgba(255, 255, 255, 0.16)',
  'inline-xs-neutral-dark-20': 'inset 0 0 0 0.0625rem rgba(38, 52, 64, 0.2)',
  'inline-xs-neutral-light-20': 'inset 0 0 0 0.0625rem rgba(207, 218, 226, 0.2)',
  'inline-xs-purple-dark-20': 'inset 0 0 0 0.0625rem rgba(84, 61, 255, 0.2)',
  'inline-xs-purple-light-20': 'inset 0 0 0 0.0625rem rgba(165, 153, 255, 0.2)',
  'inline-xs-teal-dark-20': 'inset 0 0 0 0.0625rem rgba(0, 141, 163, 0.2)',
  'inline-xs-teal-light-20': 'inset 0 0 0 0.0625rem rgba(100, 170, 180, 0.2)',
  'inline-xs-orange-dark-20': 'inset 0 0 0 0.0625rem rgba(255, 85, 0, 0.2)',
  'inline-xs-orange-light-20': 'inset 0 0 0 0.0625rem rgba(246, 126, 85, 0.2)',
  'inline-xs-red-dark-20': 'inset 0 0 0 0.0625rem rgba(214, 64, 61, 0.2)',
  'inline-xs-red-light-20': 'inset 0 0 0 0.0625rem rgba(255, 105, 102, 0.2)',
  'inline-xs-yellow-dark-20': 'inset 0 0 0 0.0625rem rgba(194, 113, 0, 0.2)',
  'inline-xs-yellow-light-20': 'inset 0 0 0 0.0625rem rgba(255, 159, 26, 0.2)',
  'inline-xs-green-dark-20': 'inset 0 0 0 0.0625rem rgba(0, 133, 99, 0.2)',
  'inline-xs-green-light-20': 'inset 0 0 0 0.0625rem rgba(0, 189, 142, 0.2)',
  'inline-xs-blue-dark-20': 'inset 0 0 0 0.0625rem rgba(0, 118, 214, 0.2)',
  'inline-xs-blue-light-20': 'inset 0 0 0 0.0625rem rgba(41, 159, 255, 0.2)',
  'inline-xs-white-20': 'inset 0 0 0 0.0625rem rgba(255, 255, 255, 0.2)',
  'inline-xs-neutral-dark-24': 'inset 0 0 0 0.0625rem rgba(38, 52, 64, 0.24)',
  'inline-xs-neutral-light-24': 'inset 0 0 0 0.0625rem rgba(207, 218, 226, 0.24)',
  'inline-xs-purple-dark-24': 'inset 0 0 0 0.0625rem rgba(84, 61, 255, 0.24)',
  'inline-xs-purple-light-24': 'inset 0 0 0 0.0625rem rgba(165, 153, 255, 0.24)',
  'inline-xs-teal-dark-24': 'inset 0 0 0 0.0625rem rgba(0, 141, 163, 0.24)',
  'inline-xs-teal-light-24': 'inset 0 0 0 0.0625rem rgba(100, 170, 180, 0.24)',
  'inline-xs-orange-dark-24': 'inset 0 0 0 0.0625rem rgba(255, 85, 0, 0.24)',
  'inline-xs-orange-light-24': 'inset 0 0 0 0.0625rem rgba(246, 126, 85, 0.24)',
  'inline-xs-red-dark-24': 'inset 0 0 0 0.0625rem rgba(214, 64, 61, 0.24)',
  'inline-xs-red-light-24': 'inset 0 0 0 0.0625rem rgba(255, 105, 102, 0.24)',
  'inline-xs-yellow-dark-24': 'inset 0 0 0 0.0625rem rgba(194, 113, 0, 0.24)',
  'inline-xs-yellow-light-24': 'inset 0 0 0 0.0625rem rgba(255, 159, 26, 0.24)',
  'inline-xs-green-dark-24': 'inset 0 0 0 0.0625rem rgba(0, 133, 99, 0.24)',
  'inline-xs-green-light-24': 'inset 0 0 0 0.0625rem rgba(0, 189, 142, 0.24)',
  'inline-xs-blue-dark-24': 'inset 0 0 0 0.0625rem rgba(0, 118, 214, 0.24)',
  'inline-xs-blue-light-24': 'inset 0 0 0 0.0625rem rgba(41, 159, 255, 0.24)',
  'inline-xs-white-24': 'inset 0 0 0 0.0625rem rgba(255, 255, 255, 0.24)',
  'inline-xs-neutral-dark-32': 'inset 0 0 0 0.0625rem rgba(38, 52, 64, 0.32)',
  'inline-xs-neutral-light-32': 'inset 0 0 0 0.0625rem rgba(207, 218, 226, 0.32)',
  'inline-xs-purple-dark-32': 'inset 0 0 0 0.0625rem rgba(84, 61, 255, 0.32)',
  'inline-xs-purple-light-32': 'inset 0 0 0 0.0625rem rgba(165, 153, 255, 0.32)',
  'inline-xs-teal-dark-32': 'inset 0 0 0 0.0625rem rgba(0, 141, 163, 0.32)',
  'inline-xs-teal-light-32': 'inset 0 0 0 0.0625rem rgba(100, 170, 180, 0.32)',
  'inline-xs-orange-dark-32': 'inset 0 0 0 0.0625rem rgba(255, 85, 0, 0.32)',
  'inline-xs-orange-light-32': 'inset 0 0 0 0.0625rem rgba(246, 126, 85, 0.32)',
  'inline-xs-red-dark-32': 'inset 0 0 0 0.0625rem rgba(214, 64, 61, 0.32)',
  'inline-xs-red-light-32': 'inset 0 0 0 0.0625rem rgba(255, 105, 102, 0.32)',
  'inline-xs-yellow-dark-32': 'inset 0 0 0 0.0625rem rgba(194, 113, 0, 0.32)',
  'inline-xs-yellow-light-32': 'inset 0 0 0 0.0625rem rgba(255, 159, 26, 0.32)',
  'inline-xs-green-dark-32': 'inset 0 0 0 0.0625rem rgba(0, 133, 99, 0.32)',
  'inline-xs-green-light-32': 'inset 0 0 0 0.0625rem rgba(0, 189, 142, 0.32)',
  'inline-xs-blue-dark-32': 'inset 0 0 0 0.0625rem rgba(0, 118, 214, 0.32)',
  'inline-xs-blue-light-32': 'inset 0 0 0 0.0625rem rgba(41, 159, 255, 0.32)',
  'inline-xs-white-32': 'inset 0 0 0 0.0625rem rgba(255, 255, 255, 0.32)',
  'inline-xs-neutral-dark-40': 'inset 0 0 0 0.0625rem rgba(38, 52, 64, 0.4)',
  'inline-xs-neutral-light-40': 'inset 0 0 0 0.0625rem rgba(207, 218, 226, 0.4)',
  'inline-xs-purple-dark-40': 'inset 0 0 0 0.0625rem rgba(84, 61, 255, 0.4)',
  'inline-xs-purple-light-40': 'inset 0 0 0 0.0625rem rgba(165, 153, 255, 0.4)',
  'inline-xs-teal-dark-40': 'inset 0 0 0 0.0625rem rgba(0, 141, 163, 0.4)',
  'inline-xs-teal-light-40': 'inset 0 0 0 0.0625rem rgba(100, 170, 180, 0.4)',
  'inline-xs-orange-dark-40': 'inset 0 0 0 0.0625rem rgba(255, 85, 0, 0.4)',
  'inline-xs-orange-light-40': 'inset 0 0 0 0.0625rem rgba(246, 126, 85, 0.4)',
  'inline-xs-red-dark-40': 'inset 0 0 0 0.0625rem rgba(214, 64, 61, 0.4)',
  'inline-xs-red-light-40': 'inset 0 0 0 0.0625rem rgba(255, 105, 102, 0.4)',
  'inline-xs-yellow-dark-40': 'inset 0 0 0 0.0625rem rgba(194, 113, 0, 0.4)',
  'inline-xs-yellow-light-40': 'inset 0 0 0 0.0625rem rgba(255, 159, 26, 0.4)',
  'inline-xs-green-dark-40': 'inset 0 0 0 0.0625rem rgba(0, 133, 99, 0.4)',
  'inline-xs-green-light-40': 'inset 0 0 0 0.0625rem rgba(0, 189, 142, 0.4)',
  'inline-xs-blue-dark-40': 'inset 0 0 0 0.0625rem rgba(0, 118, 214, 0.4)',
  'inline-xs-blue-light-40': 'inset 0 0 0 0.0625rem rgba(41, 159, 255, 0.4)',
  'inline-xs-white-40': 'inset 0 0 0 0.0625rem rgba(255, 255, 255, 0.4)',
  'inline-xs-neutral-dark-48': 'inset 0 0 0 0.0625rem rgba(38, 52, 64, 0.48)',
  'inline-xs-neutral-light-48': 'inset 0 0 0 0.0625rem rgba(207, 218, 226, 0.48)',
  'inline-xs-purple-dark-48': 'inset 0 0 0 0.0625rem rgba(84, 61, 255, 0.48)',
  'inline-xs-purple-light-48': 'inset 0 0 0 0.0625rem rgba(165, 153, 255, 0.48)',
  'inline-xs-teal-dark-48': 'inset 0 0 0 0.0625rem rgba(0, 141, 163, 0.48)',
  'inline-xs-teal-light-48': 'inset 0 0 0 0.0625rem rgba(100, 170, 180, 0.48)',
  'inline-xs-orange-dark-48': 'inset 0 0 0 0.0625rem rgba(255, 85, 0, 0.48)',
  'inline-xs-orange-light-48': 'inset 0 0 0 0.0625rem rgba(246, 126, 85, 0.48)',
  'inline-xs-red-dark-48': 'inset 0 0 0 0.0625rem rgba(214, 64, 61, 0.48)',
  'inline-xs-red-light-48': 'inset 0 0 0 0.0625rem rgba(255, 105, 102, 0.48)',
  'inline-xs-yellow-dark-48': 'inset 0 0 0 0.0625rem rgba(194, 113, 0, 0.48)',
  'inline-xs-yellow-light-48': 'inset 0 0 0 0.0625rem rgba(255, 159, 26, 0.48)',
  'inline-xs-green-dark-48': 'inset 0 0 0 0.0625rem rgba(0, 133, 99, 0.48)',
  'inline-xs-green-light-48': 'inset 0 0 0 0.0625rem rgba(0, 189, 142, 0.48)',
  'inline-xs-blue-dark-48': 'inset 0 0 0 0.0625rem rgba(0, 118, 214, 0.48)',
  'inline-xs-blue-light-48': 'inset 0 0 0 0.0625rem rgba(41, 159, 255, 0.48)',
  'inline-xs-white-48': 'inset 0 0 0 0.0625rem rgba(255, 255, 255, 0.48)',
  'inline-xs-neutral-dark-64': 'inset 0 0 0 0.0625rem rgba(38, 52, 64, 0.64)',
  'inline-xs-neutral-light-64': 'inset 0 0 0 0.0625rem rgba(207, 218, 226, 0.64)',
  'inline-xs-purple-dark-64': 'inset 0 0 0 0.0625rem rgba(84, 61, 255, 0.64)',
  'inline-xs-purple-light-64': 'inset 0 0 0 0.0625rem rgba(165, 153, 255, 0.64)',
  'inline-xs-teal-dark-64': 'inset 0 0 0 0.0625rem rgba(0, 141, 163, 0.64)',
  'inline-xs-teal-light-64': 'inset 0 0 0 0.0625rem rgba(100, 170, 180, 0.64)',
  'inline-xs-orange-dark-64': 'inset 0 0 0 0.0625rem rgba(255, 85, 0, 0.64)',
  'inline-xs-orange-light-64': 'inset 0 0 0 0.0625rem rgba(246, 126, 85, 0.64)',
  'inline-xs-red-dark-64': 'inset 0 0 0 0.0625rem rgba(214, 64, 61, 0.64)',
  'inline-xs-red-light-64': 'inset 0 0 0 0.0625rem rgba(255, 105, 102, 0.64)',
  'inline-xs-yellow-dark-64': 'inset 0 0 0 0.0625rem rgba(194, 113, 0, 0.64)',
  'inline-xs-yellow-light-64': 'inset 0 0 0 0.0625rem rgba(255, 159, 26, 0.64)',
  'inline-xs-green-dark-64': 'inset 0 0 0 0.0625rem rgba(0, 133, 99, 0.64)',
  'inline-xs-green-light-64': 'inset 0 0 0 0.0625rem rgba(0, 189, 142, 0.64)',
  'inline-xs-blue-dark-64': 'inset 0 0 0 0.0625rem rgba(0, 118, 214, 0.64)',
  'inline-xs-blue-light-64': 'inset 0 0 0 0.0625rem rgba(41, 159, 255, 0.64)',
  'inline-xs-white-64': 'inset 0 0 0 0.0625rem rgba(255, 255, 255, 0.64)',
  'inline-xs-neutral-dark-80': 'inset 0 0 0 0.0625rem rgba(38, 52, 64, 0.8)',
  'inline-xs-neutral-light-80': 'inset 0 0 0 0.0625rem rgba(207, 218, 226, 0.8)',
  'inline-xs-purple-dark-80': 'inset 0 0 0 0.0625rem rgba(84, 61, 255, 0.8)',
  'inline-xs-purple-light-80': 'inset 0 0 0 0.0625rem rgba(165, 153, 255, 0.8)',
  'inline-xs-teal-dark-80': 'inset 0 0 0 0.0625rem rgba(0, 141, 163, 0.8)',
  'inline-xs-teal-light-80': 'inset 0 0 0 0.0625rem rgba(100, 170, 180, 0.8)',
  'inline-xs-orange-dark-80': 'inset 0 0 0 0.0625rem rgba(255, 85, 0, 0.8)',
  'inline-xs-orange-light-80': 'inset 0 0 0 0.0625rem rgba(246, 126, 85, 0.8)',
  'inline-xs-red-dark-80': 'inset 0 0 0 0.0625rem rgba(214, 64, 61, 0.8)',
  'inline-xs-red-light-80': 'inset 0 0 0 0.0625rem rgba(255, 105, 102, 0.8)',
  'inline-xs-yellow-dark-80': 'inset 0 0 0 0.0625rem rgba(194, 113, 0, 0.8)',
  'inline-xs-yellow-light-80': 'inset 0 0 0 0.0625rem rgba(255, 159, 26, 0.8)',
  'inline-xs-green-dark-80': 'inset 0 0 0 0.0625rem rgba(0, 133, 99, 0.8)',
  'inline-xs-green-light-80': 'inset 0 0 0 0.0625rem rgba(0, 189, 142, 0.8)',
  'inline-xs-blue-dark-80': 'inset 0 0 0 0.0625rem rgba(0, 118, 214, 0.8)',
  'inline-xs-blue-light-80': 'inset 0 0 0 0.0625rem rgba(41, 159, 255, 0.8)',
  'inline-xs-white-80': 'inset 0 0 0 0.0625rem rgba(255, 255, 255, 0.8)',
  'inline-xs-neutral-dark-100': 'inset 0 0 0 0.0625rem rgba(38, 52, 64, 1)',
  'inline-xs-neutral-light-100': 'inset 0 0 0 0.0625rem rgba(207, 218, 226, 1)',
  'inline-xs-purple-dark-100': 'inset 0 0 0 0.0625rem rgba(84, 61, 255, 1)',
  'inline-xs-purple-light-100': 'inset 0 0 0 0.0625rem rgba(165, 153, 255, 1)',
  'inline-xs-teal-dark-100': 'inset 0 0 0 0.0625rem rgba(0, 141, 163, 1)',
  'inline-xs-teal-light-100': 'inset 0 0 0 0.0625rem rgba(100, 170, 180, 1)',
  'inline-xs-orange-dark-100': 'inset 0 0 0 0.0625rem rgba(255, 85, 0, 1)',
  'inline-xs-orange-light-100': 'inset 0 0 0 0.0625rem rgba(246, 126, 85, 1)',
  'inline-xs-red-dark-100': 'inset 0 0 0 0.0625rem rgba(214, 64, 61, 1)',
  'inline-xs-red-light-100': 'inset 0 0 0 0.0625rem rgba(255, 105, 102, 1)',
  'inline-xs-yellow-dark-100': 'inset 0 0 0 0.0625rem rgba(194, 113, 0, 1)',
  'inline-xs-yellow-light-100': 'inset 0 0 0 0.0625rem rgba(255, 159, 26, 1)',
  'inline-xs-green-dark-100': 'inset 0 0 0 0.0625rem rgba(0, 133, 99, 1)',
  'inline-xs-green-light-100': 'inset 0 0 0 0.0625rem rgba(0, 189, 142, 1)',
  'inline-xs-blue-dark-100': 'inset 0 0 0 0.0625rem rgba(0, 118, 214, 1)',
  'inline-xs-blue-light-100': 'inset 0 0 0 0.0625rem rgba(41, 159, 255, 1)',
  'inline-xs-white-100': 'inset 0 0 0 0.0625rem rgba(255, 255, 255, 1)',
}
